module.exports = __webpack_public_path__ + "img/csr_swiper_08.4e411629.jpg";